import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/services/auth.guard';
import { MfaoptionsComponent } from './mfaoptions/mfaoptions.component';
import { TriggermfaComponent } from './triggermfa/triggermfa.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

const routes: Routes = [
  // { path: 'home', component: HomeComponent, data: { title: 'Home' } },
  { path: 'mfaoptions', component: MfaoptionsComponent, data: { title: 'MFA OPTIONS' } },
  { path: 'triggermfa', component: TriggermfaComponent, data: { title: 'MFA OPTIONS' } },


  {
    path: 'enterprise',
    loadChildren: () => import('./employer/employer.module').then(m => m.EmployerModule),
      canActivate: [AuthGuard],
      data: { 
        roles: ['ROLE_INSTITUTION_ADMIN'],
        title: 'Org-Contracts',
     }
  },

  {
    path: 'superadmin',
    loadChildren: () => import('./superadmin/superadmin.module').then(m => m.SuperadminModule),
    canActivate: [AuthGuard],
    data: { 
      roles: ['ROLE_MFA_SUPERADMIN'],
      title: 'Org-Contracts',
   }
  },
  {
    path: 'support',
    loadChildren: () => import('./support/support.module').then(m => m.SupportModule),
    canActivate: [AuthGuard],
    data: { 
      roles: ['ROLE_MFA_SUPPORT'],
      title: 'Org-Contracts',
   }
  },
  {
    path: "404",
    component: UnauthorizedComponent,
  },
  {
    path: '',
    loadChildren: () => import('./public-pages/public-pages.module').then(m => m.PublicPagesModule),
  },
  {
    path: "**",
    redirectTo: "login"
  }
]; 

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
